import React, { FC } from 'react';
import { Wrapper } from '../../Wrapper/Wrapper';
import { CustomRadio, StyledInput } from './RadioBase.styles';

export interface RadioBaseProps extends Omit<React.ComponentPropsWithoutRef<'input'>, 'size'> {
  hideFocus?: boolean;
}

export const RadioBase: FC<RadioBaseProps> = ({
  checked,
  onChange,
  disabled,
  /**
   * Useful to use the radio input inside a visual picker
   */
  hideFocus = false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  children,
  ...rest
}) => (
  <Wrapper css="height: 16px">
    <StyledInput
      checked={checked}
      onChange={onChange}
      type="radio"
      disabled={disabled}
      hideFocus={hideFocus}
      {...rest}
    />

    <CustomRadio disabled={disabled} checked={checked} />
  </Wrapper>
);
